// extracted by mini-css-extract-plugin
export default {"tabsList":"VgA6tXVVwSEc_q7B6d94"};